var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('generic-block-options',{attrs:{"block":_vm.block,"hide-text-color":true,"save-url":_vm.saveUrl,"has-tab-titles":_vm.hasTabTitles}})}
var staticRenderFns = []

export { render, staticRenderFns }